import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Reactive1jy75v4li6ldv as Reactive } from '../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import { Companion_getInstance23x6zslwzj0st as Companion_getInstance } from '../models/data.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance_0,
  toDuration7gy6v749ektt as toDuration,
  Duration5ynfiptaqcrg as Duration,
  Duration__compareTo_impl_pchp0f1efu9z6fxx84c as Duration__compareTo_impl_pchp0f,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  $3l5vvh8yg0ier as $,
  orPromise1iucc2to2udt2 as orPromise,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  _ReactiveState___init__impl__fvdp9b3rxdz1mjh763m as _ReactiveState___init__impl__fvdp9b,
  Companion_getInstance3byfqsk8b0ql6 as Companion_getInstance_1,
} from '../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { ReactiveLoadings35224pps2d9 as ReactiveLoading } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { DependencyChangeListener1518w8dt8yuu7 as DependencyChangeListener } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { RawReactive253xb355brtjj as RawReactive } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { EmptyCoroutineContext_instance3dshdbvg42f79 as EmptyCoroutineContext_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContextImpl.mjs';
import { Key_getInstance20c05dl0yuxib as Key_getInstance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineDispatcher.mjs';
import {
  CoroutineStart_DEFAULT_getInstance3qi77grrvmsn3 as CoroutineStart_DEFAULT_getInstance,
  CoroutineStart_UNDISPATCHED_getInstance36t7e2kqqnuqp as CoroutineStart_UNDISPATCHED_getInstance,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineStart.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  Monotonic_instancewn07e60bp6rj as Monotonic_instance,
  ValueTimeMark__minus_impl_f87sko2z1nwmc9w7tpq as ValueTimeMark__minus_impl_f87sko,
  ValueTimeMark__elapsedNow_impl_eonqvs31ikzp5dku7pk as ValueTimeMark__elapsedNow_impl_eonqvs,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/TimeSource.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_actionInstrumentors() {
  _init_properties_Action_kt__mgyt1y();
  return actionInstrumentors;
}
var actionInstrumentors;
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.defaultClearErrorOnDependencyChange_1 = true;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_2() {
  return Companion_instance;
}
var ActionClass;
function Action() {
  if (ActionClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Action', VOID, VOID, [Reactive()]);
    ActionClass = $;
  }
  return ActionClass;
}
function Action_0(title, icon, clearErrorOnDependencyChange, keepRunningWhile, frequencyCap, ignoreRetryWhileRunning, action) {
  icon = icon === VOID ? Companion_getInstance().send_1 : icon;
  clearErrorOnDependencyChange = clearErrorOnDependencyChange === VOID ? Companion_instance.defaultClearErrorOnDependencyChange_1 : clearErrorOnDependencyChange;
  keepRunningWhile = keepRunningWhile === VOID ? get_AppScope() : keepRunningWhile;
  var tmp;
  if (frequencyCap === VOID) {
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance_0();
    tmp = toDuration(500, DurationUnit_MILLISECONDS_getInstance());
  } else {
    tmp = frequencyCap;
  }
  frequencyCap = tmp;
  ignoreRetryWhileRunning = ignoreRetryWhileRunning === VOID ? true : ignoreRetryWhileRunning;
  _init_properties_Action_kt__mgyt1y();
  var tmp_0;
  if (clearErrorOnDependencyChange) {
    tmp_0 = new (DependentAction())(title, icon, keepRunningWhile, ignoreRetryWhileRunning, VOID, action);
  } else {
    tmp_0 = new (RetryableAction())(title, icon, keepRunningWhile, ignoreRetryWhileRunning, VOID, action);
  }
  // Inline function 'kotlin.let' call
  var it = tmp_0;
  var tmp_1;
  var tmp_2 = frequencyCap;
  if ((tmp_2 == null ? null : new (Duration())(tmp_2)) == null) {
    tmp_1 = null;
  } else {
    var tmp_3 = frequencyCap;
    // Inline function 'kotlin.let' call
    var f = (tmp_3 == null ? null : new (Duration())(tmp_3)).rawValue_1;
    tmp_1 = new (FrequencyCapAction())(it, f);
  }
  var tmp1_elvis_lhs = tmp_1;
  return tmp1_elvis_lhs == null ? it : tmp1_elvis_lhs;
}
function DependentAction$startAction$slambda($instrumentations, this$0, $done) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = $instrumentations.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      element.onStart_1();
    }
    var tmp;
    try {
      // Inline function 'com.lightningkite.reactive.core.reactiveState' call
      var tmp_0;
      try {
        yield* $(this$0.action_1($this$launch, $completion), $completion);
        tmp_0 = _ReactiveState___init__impl__fvdp9b(true);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof CancellationException()) {
          var e = $p;
          throw e;
        } else {
          if ($p instanceof ReactiveLoading()) {
            var _unused_var__etf5q3 = $p;
            tmp_1 = Companion_getInstance_1().notReady_1;
          } else {
            if ($p instanceof Exception()) {
              var e_0 = $p;
              tmp_1 = Companion_getInstance_1().exception_iibuh2_k$(e_0);
            } else {
              throw $p;
            }
          }
        }
        tmp_0 = tmp_1;
      }
      var result = tmp_0;
      $done._v = true;
      this$0.reportTo_1.set_state_wnfcx0_k$(result);
      tmp = Unit_instance;
    } catch ($p_0) {
      var tmp_2;
      if ($p_0 instanceof Exception()) {
        var e_1 = $p_0;
        if (e_1 instanceof CancellationException())
          throw e_1;
        this$0.reportTo_1.set_state_wnfcx0_k$(Companion_getInstance_1().exception_iibuh2_k$(e_1));
        tmp_2 = Unit_instance;
      } else {
        throw $p_0;
      }
      tmp = tmp_2;
    }
    finally {
      this$0.dependencyBlockEnd_6wfk9j_k$();
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_0 = $instrumentations.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
        var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
        element_0.onEnd_1();
      }
    }
    return Unit_instance;
  }), 1);
}
var DependentActionClass;
function DependentAction() {
  if (DependentActionClass === VOID) {
    class $ extends DependencyChangeListener() {
      constructor(title, icon, keepRunningWhile, ignoreRetryWhileRunning, reportTo, action) {
        keepRunningWhile = keepRunningWhile === VOID ? get_AppScope() : keepRunningWhile;
        ignoreRetryWhileRunning = ignoreRetryWhileRunning === VOID ? false : ignoreRetryWhileRunning;
        reportTo = reportTo === VOID ? RawReactive().new_com_lightningkite_reactive_core_RawReactive_4h91ij_k$(_ReactiveState___init__impl__fvdp9b(false)) : reportTo;
        super();
        this.title_1 = title;
        this.icon_1 = icon;
        this.keepRunningWhile_1 = keepRunningWhile;
        this.ignoreRetryWhileRunning_1 = ignoreRetryWhileRunning;
        this.reportTo_1 = reportTo;
        this.action_1 = action;
        this.lastJob_1 = null;
      }
      get_title_iz32un_k$() {
        return this.title_1;
      }
      onDependencyNotReady_ntxysq_k$() {
        return this.onDependencyChange_yaqozu_k$();
      }
      onDependencyChange_yaqozu_k$() {
        var tmp0_safe_receiver = this.lastJob_1;
        if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_isCompleted_a6j6c8_k$()) === false)
          return Unit_instance;
        this.reportTo_1.set_state_wnfcx0_k$(_ReactiveState___init__impl__fvdp9b(false));
      }
      startAction_u0zgbm_k$(scope) {
        var tmp;
        if (this.ignoreRetryWhileRunning_1) {
          var tmp0_safe_receiver = this.lastJob_1;
          tmp = (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_isCompleted_a6j6c8_k$()) === false;
        } else {
          tmp = false;
        }
        if (tmp)
          return Unit_instance;
        this.dependencyBlockStart_qxo3ow_k$();
        var tmp1_safe_receiver = this.lastJob_1;
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.cancel$default_8haxne_k$();
        }
        // Inline function 'kotlin.collections.mapNotNull' call
        var tmp0 = get_actionInstrumentors();
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          var tmp0_safe_receiver_0 = element(scope, this.title_1);
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            destination.add_utx5q5_k$(tmp0_safe_receiver_0);
          }
        }
        var instrumentations = destination;
        // Inline function 'kotlin.collections.fold' call
        var accumulator = EmptyCoroutineContext_instance;
        var _iterator__ex2g4s_0 = instrumentations.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
          accumulator = accumulator.plus_s13ygv_k$(element_0.coroutineContext_1);
        }
        var extraContext = accumulator;
        var tmp_0 = this;
        var tmp2_elvis_lhs = this.keepRunningWhile_1;
        // Inline function 'kotlin.let' call
        var tmp0_0 = tmp2_elvis_lhs == null ? scope : tmp2_elvis_lhs;
        var tmp$ret$10;
        $l$block_0: {
          var done = {_v: false};
          var tmp_1 = extraContext.plus_s13ygv_k$(this);
          var tmp_2;
          var tmp0_safe_receiver_1 = tmp0_0.get_coroutineContext_115oqo_k$().get_y2st91_k$(Key_getInstance());
          if ((tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.isDispatchNeeded_ft82v4_k$(tmp0_0.get_coroutineContext_115oqo_k$())) === false) {
            tmp_2 = CoroutineStart_UNDISPATCHED_getInstance();
          } else {
            tmp_2 = CoroutineStart_DEFAULT_getInstance();
          }
          var tmp_3 = tmp_2;
          var job = launch(tmp0_0, tmp_1, tmp_3, DependentAction$startAction$slambda(instrumentations, this, done));
          if (done._v) {
            tmp$ret$10 = null;
            break $l$block_0;
          } else {
            this.reportTo_1.set_state_wnfcx0_k$(Companion_getInstance_1().notReady_1);
            tmp$ret$10 = job;
            break $l$block_0;
          }
        }
        tmp_0.lastJob_1 = tmp$ret$10;
      }
      cancel_2l89ey_k$() {
        super.cancel_2l89ey_k$();
        var tmp0_safe_receiver = this.lastJob_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          this.lastJob_1 = null;
          tmp0_safe_receiver.cancel$default_8haxne_k$();
        }
      }
      toString() {
        return 'DependentAction(' + this.title_1 + ')';
      }
      get_state_9u1hs7_k$() {
        return this.reportTo_1.get_state_wc71uu_k$();
      }
      get_state_wc71uu_k$() {
        return this.get_state_9u1hs7_k$();
      }
      addListener_6y9mct_k$(listener) {
        return this.reportTo_1.addListener_6y9mct_k$(listener);
      }
      beginUse_omrbby_k$() {
        return this.reportTo_1.beginUse_omrbby_k$();
      }
    }
    initMetadataForClass($, 'DependentAction', VOID, VOID, [Action(), Reactive()]);
    DependentActionClass = $;
  }
  return DependentActionClass;
}
function RetryableAction$startAction$slambda($instrumentations, this$0, $done) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = $instrumentations.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      element.onStart_1();
    }
    var tmp;
    try {
      // Inline function 'com.lightningkite.reactive.core.reactiveState' call
      var tmp_0;
      try {
        yield* $(this$0.action_1($this$launch, $completion), $completion);
        tmp_0 = _ReactiveState___init__impl__fvdp9b(true);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof CancellationException()) {
          var e = $p;
          throw e;
        } else {
          if ($p instanceof ReactiveLoading()) {
            var _unused_var__etf5q3 = $p;
            tmp_1 = Companion_getInstance_1().notReady_1;
          } else {
            if ($p instanceof Exception()) {
              var e_0 = $p;
              tmp_1 = Companion_getInstance_1().exception_iibuh2_k$(e_0);
            } else {
              throw $p;
            }
          }
        }
        tmp_0 = tmp_1;
      }
      var result = tmp_0;
      $done._v = true;
      this$0.reportTo_1.set_state_wnfcx0_k$(result);
      tmp = Unit_instance;
    } catch ($p_0) {
      var tmp_2;
      if ($p_0 instanceof Exception()) {
        var e_1 = $p_0;
        if (e_1 instanceof CancellationException())
          throw e_1;
        this$0.reportTo_1.set_state_wnfcx0_k$(Companion_getInstance_1().exception_iibuh2_k$(e_1));
        tmp_2 = Unit_instance;
      } else {
        throw $p_0;
      }
      tmp = tmp_2;
    }
    finally {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_0 = $instrumentations.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
        var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
        element_0.onEnd_1();
      }
    }
    return Unit_instance;
  }), 1);
}
var RetryableActionClass;
function RetryableAction() {
  if (RetryableActionClass === VOID) {
    class $ {
      constructor(title, icon, keepRunningWhile, ignoreRetryWhileRunning, reportTo, action) {
        keepRunningWhile = keepRunningWhile === VOID ? get_AppScope() : keepRunningWhile;
        ignoreRetryWhileRunning = ignoreRetryWhileRunning === VOID ? false : ignoreRetryWhileRunning;
        reportTo = reportTo === VOID ? RawReactive().new_com_lightningkite_reactive_core_RawReactive_4h91ij_k$(_ReactiveState___init__impl__fvdp9b(false)) : reportTo;
        this.title_1 = title;
        this.icon_1 = icon;
        this.keepRunningWhile_1 = keepRunningWhile;
        this.ignoreRetryWhileRunning_1 = ignoreRetryWhileRunning;
        this.reportTo_1 = reportTo;
        this.action_1 = action;
        this.lastJob_1 = null;
      }
      get_title_iz32un_k$() {
        return this.title_1;
      }
      startAction_u0zgbm_k$(scope) {
        var tmp;
        if (this.ignoreRetryWhileRunning_1) {
          var tmp0_safe_receiver = this.lastJob_1;
          tmp = (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_isCompleted_a6j6c8_k$()) === false;
        } else {
          tmp = false;
        }
        if (tmp)
          return Unit_instance;
        var tmp1_safe_receiver = this.lastJob_1;
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.cancel$default_8haxne_k$();
        }
        // Inline function 'kotlin.collections.mapNotNull' call
        var tmp0 = get_actionInstrumentors();
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          var tmp0_safe_receiver_0 = element(scope, this.title_1);
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            destination.add_utx5q5_k$(tmp0_safe_receiver_0);
          }
        }
        var instrumentations = destination;
        // Inline function 'kotlin.collections.fold' call
        var accumulator = EmptyCoroutineContext_instance;
        var _iterator__ex2g4s_0 = instrumentations.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
          accumulator = accumulator.plus_s13ygv_k$(element_0.coroutineContext_1);
        }
        var extraContext = accumulator;
        var tmp_0 = this;
        var tmp2_elvis_lhs = this.keepRunningWhile_1;
        // Inline function 'kotlin.let' call
        var tmp0_0 = tmp2_elvis_lhs == null ? scope : tmp2_elvis_lhs;
        var tmp$ret$10;
        $l$block_0: {
          var done = {_v: false};
          var tmp_1;
          var tmp0_safe_receiver_1 = tmp0_0.get_coroutineContext_115oqo_k$().get_y2st91_k$(Key_getInstance());
          if ((tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.isDispatchNeeded_ft82v4_k$(tmp0_0.get_coroutineContext_115oqo_k$())) === false) {
            tmp_1 = CoroutineStart_UNDISPATCHED_getInstance();
          } else {
            tmp_1 = CoroutineStart_DEFAULT_getInstance();
          }
          var tmp_2 = tmp_1;
          var job = launch(tmp0_0, extraContext, tmp_2, RetryableAction$startAction$slambda(instrumentations, this, done));
          if (done._v) {
            tmp$ret$10 = null;
            break $l$block_0;
          } else {
            this.reportTo_1.set_state_wnfcx0_k$(Companion_getInstance_1().notReady_1);
            tmp$ret$10 = job;
            break $l$block_0;
          }
        }
        tmp_0.lastJob_1 = tmp$ret$10;
      }
      toString() {
        return 'RetryableAction(' + this.title_1 + ')';
      }
      get_state_9u1hs7_k$() {
        return this.reportTo_1.get_state_wc71uu_k$();
      }
      get_state_wc71uu_k$() {
        return this.get_state_9u1hs7_k$();
      }
      addListener_6y9mct_k$(listener) {
        return this.reportTo_1.addListener_6y9mct_k$(listener);
      }
      beginUse_omrbby_k$() {
        return this.reportTo_1.beginUse_omrbby_k$();
      }
    }
    initMetadataForClass($, 'RetryableAction', VOID, VOID, [Action(), Reactive()]);
    RetryableActionClass = $;
  }
  return RetryableActionClass;
}
var FrequencyCapActionClass;
function FrequencyCapAction() {
  if (FrequencyCapActionClass === VOID) {
    class $ {
      constructor(wraps, frequencyCap) {
        var tmp;
        if (frequencyCap === VOID) {
          // Inline function 'kotlin.time.Companion.milliseconds' call
          Companion_getInstance_0();
          tmp = toDuration(500, DurationUnit_MILLISECONDS_getInstance());
        } else {
          tmp = frequencyCap;
        }
        frequencyCap = tmp;
        this.wraps_1 = wraps;
        this.frequencyCap_1 = frequencyCap;
        var tmp_0 = this;
        var tmp_1 = ValueTimeMark__minus_impl_f87sko(Monotonic_instance.markNow_ns2ype_k$(), this.frequencyCap_1);
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance_0();
        var tmp$ret$1 = toDuration(1, DurationUnit_MILLISECONDS_getInstance());
        tmp_0.lastInvoked_1 = ValueTimeMark__minus_impl_f87sko(tmp_1, tmp$ret$1);
      }
      startAction_u0zgbm_k$(scope) {
        if (Duration__compareTo_impl_pchp0f(ValueTimeMark__elapsedNow_impl_eonqvs(this.lastInvoked_1), this.frequencyCap_1) > 0) {
          this.lastInvoked_1 = Monotonic_instance.markNow_ns2ype_k$();
          this.wraps_1.startAction_u0zgbm_k$(scope);
        }
      }
      toString() {
        return 'FrequencyCapAction(' + toString(this.wraps_1) + ')';
      }
      get_title_iz32un_k$() {
        return this.wraps_1.get_title_iz32un_k$();
      }
      get_state_9u1hs7_k$() {
        return this.wraps_1.get_state_wc71uu_k$();
      }
      get_state_wc71uu_k$() {
        return this.get_state_9u1hs7_k$();
      }
      addListener_6y9mct_k$(listener) {
        return this.wraps_1.addListener_6y9mct_k$(listener);
      }
      beginUse_omrbby_k$() {
        return this.wraps_1.beginUse_omrbby_k$();
      }
    }
    initMetadataForClass($, 'FrequencyCapAction', VOID, VOID, [Action()]);
    FrequencyCapActionClass = $;
  }
  return FrequencyCapActionClass;
}
var properties_initialized_Action_kt_vlp01k;
function _init_properties_Action_kt__mgyt1y() {
  if (!properties_initialized_Action_kt_vlp01k) {
    properties_initialized_Action_kt_vlp01k = true;
    // Inline function 'kotlin.collections.mutableListOf' call
    actionInstrumentors = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  }
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Action_0 as Action2nhdpxpznfsbd,
  Action as Action18dong6ke5uus,
};
//endregion

//# sourceMappingURL=Action.mjs.map
